<script>
import ProInput from '$common/ProInput'
export default {
  name: 'PasswordReset',
  components: {
    'pro-input': ProInput,
  },
  props: {
    options: {
      required: true,
    }
  },
  data () {
    return {
      email: ''
    }
  },
  methods: {
    async onSubmit(){
      this.$auth.sendPasswordResetEmail(this.email).then(() => {
        this.$toast('Password reset email sent.')
        this.$modals.hide('password-reset')
      }).catch((e) => {
        console.error(e)
        this.$toast('Email not sent. Please try again.')
      });
    }
  },
  mounted () {
    this.email = this.options.email || ''
  },
}
</script>

<template lang="pug">
  #note-main.modal-main
    .note-container.modal-container
      .title Reset password
      .content
        .description If there is an account associated with this address, we will send an email with a link to reset your password.
        .email-section
          .pro-form
            .form-row
              pro-input(
                v-model='email'
                :options='{name: "email"}'
              )
      .action
        .button.minor(
          @click='$modals.hide(`password-reset`)'
        ) Cancel
        span
        .button.major(
          @click='onSubmit'
        ) Send Reset Request
</template>

<style lang="sass" scoped>

</style>